import Ext from 'Ext'

Ext.namespace("AT");

/**
 * Elastic text area
 *
 * Example of using:
 * <code>
 *  <textarea id="textareaId"></textarea>
 *  <script type="text/javascript">
 *      Ext.onReady(function(){
 *          new AT.ElasticTextArea({textarea: 'textareaId'});
 *      });
 *  </script>
 * </code>
 *
 * Note: if you set textarea text dynamically, you should call fitToHeight() after that.
 * For convenience, a reference to this object is added to the textarea dom node under the name 'elastic',
 * so you may do like this:
 *
 * <code>
 *  elem.value = value;
 *  if (elem.elastic)
 *    elem.elastic.fitToHeight();
 * </code>
 *
 * @constructor
 * @cfg {Element/String} textarea id or dom element of textarea (required).
 * @cfg {int} growBy additional empty space after text in textarea
 * @cfg {int} expandMax max size of textarea
 * @cfg {int} expandMin min size of textarea
 * @cfg {int} heightOfLine height of one line in text area. Applicable only for Chrome or Safari.
 *            Needs for reduce text jumping when press 'Enter' (default value is 16).
 */
const ElasticTextArea = Ext.extend(Object,
{
    textarea:null,

    div: null,

    growBy: 5,

    heightOfLine: 16,

    expandMax: -1,

    expandMin: -1,

    constructor: function(config)
    {
        Ext.apply(this, config);
        this.textarea = Ext.get(this.textarea);
        this.hCheck = !(Ext.isOpera);
        // place textarea to div
        this.div = document.createElement("div");
        this.textarea.dom.parentNode.replaceChild(this.div, this.textarea.dom);
        this.div.appendChild(this.textarea.dom);
        this.div = Ext.get(this.div);
        // listen all needed events
        this.textarea.on("keyup", this.fitToHeight, this);
        this.textarea.on("focus", this.fitToHeight, this);
        this.textarea.on("paste", this.fitToHeight, this, {delay: 40});
        this.textarea.on("blur", this.fitToHeight, this);
        this.textarea.on("cut", this.fitToHeight, this, {delay: 40});
        if(Ext.isChrome || Ext.isSafari || Ext.isOpera || Ext.isIE)
            this.textarea.on("keydown", this.fixForChrome, this);
        this.textarea.setStyle('overflow', 'hidden');
        this.div.setStyle('display', 'inline-block');
        this.growBy += this.textarea.getPadding("tb"); // consider paddings when calculate textarea height
        this.fitToHeight();
        this.textarea.dom.elastic = this;
    },

    fixForChrome: function(e)
    {
        if(e.keyCode == 13 &&
           (this.expandMax < 0 || this.textarea.getHeight() < this.expandMax) &&
                this.textarea.getHeight() > this.expandMin )
        {
            this.prevHChrome = this.textarea.getHeight();
            this.textarea.dom.style.height = (this.textarea.getHeight() + this.heightOfLine) + 'px';
            this.div.dom.style.height = this.textarea.dom.style.height;
        }
    },

    fitToHeight: function()
    {
        // find content length and box width
        var vlen = this.textarea.dom.value.length, ewidth = this.textarea.dom.offsetWidth;
        if (vlen != this.valLength || ewidth != this.boxWidth)
        {
            var prevH = this.prevHChrome? this.prevHChrome: $(this.textarea.dom).height();
            if (this.hCheck && (vlen < this.valLength || ewidth != this.boxWidth))
                this.textarea.dom.style.height = "0px";
            else
                this.textarea.dom.style.height = Math.max(0,prevH-this.growBy) + "px"; // for proper calculations with growBy greater than 0
            var h = Math.max((this.expandMin-this.growBy),
                              Math.min(this.textarea.dom.scrollHeight,
                                       this.expandMax>0?(this.expandMax-this.growBy):this.textarea.dom.scrollHeight));
            this.textarea.dom.style.overflow = (this.textarea.dom.scrollHeight > h ? "auto" : "hidden");

            this.div.setHeight(h + this.growBy, false);
            this.textarea.setHeight(h + this.growBy, false);

            this.valLength = vlen;
            this.boxWidth = ewidth;
            this.prevHChrome = false;
        }
    }
});

Ext.reg("at_elastic_textarea", ElasticTextArea);

export default ElasticTextArea


// WEBPACK FOOTER //
// ./web/js/controls/at_elastic_textarea.js